import { Container, Row, Col } from "react-bootstrap";
import Swiper from "react-id-swiper";
import { useEffect, useState } from "react";
import Link from "next/link";
import Skeleton from "react-loading-skeleton";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { workshopPurchase } from "../../lib/config";
import {
  setCartJourney,
  setCartStage,
  setCartProducts,
  resetWorkshop,
} from "../../redux/actions/cartAction";
import { useRouter } from "next/router";
import Head from "next/head";
import {
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
} from "../../redux/actions/apiActions";
import { setCurrentCategory, setSelctedId } from "redux/actions/globalAction";

const Services = ({
  categorySliderData,
  getVariants,
  id,
  globalData,
  apiData,
  setCartStage,
  setCartJourney,
  cart,
  setCartProducts,
  getWorkshopsProductCategory,
  getWorkshopsJourneyVariant,
  resetWorkshop,
  setSelctedId,
  setCurrentCategory,
  setSelected,
  selected,
}) => {
  const [swiper, setSwiper] = useState(null);
  const [data, setData] = useState([]);
  const [active, setActive] = useState(null);
  const router = useRouter();

  useEffect(() => {
    let new_data = categorySliderData.productCategory;
    let old_data = categorySliderData.categories;

    if (new_data != "" && new_data != undefined && new_data != null) {
      // Need to Check Later
      new_data = new_data.filter((item) => {
        if (cart.workshop && cart.workshop.WorkshopId == 1001) {
          if (item.ID == 4 || item.ID == 6 || item.ID == 15) {
            return true;
          } else return false;
        }
        return item?.IsDisabled == false;
      });
      let found = new_data.filter((item) => item.ID == id).length > 0;
      if (!found) {
        getWorkshopsJourneyVariant(
          cart.workshop?.Id,
          new_data[0]?.ID,
          globalData.carData?.modelId
        );
      }
      const isworkshop = localStorage.getItem("isWorkshop");
      if (
        cart.workshop &&
        cart.jobItems?.length == 0 &&
        cart.products.length == 0 &&
        !isworkshop &&
        !router.query.slug[3]
      ) {
        setData(old_data);
        setCurrentCategory(old_data);
        resetWorkshop();
        return;
      }
      setData(new_data);
      setCurrentCategory(new_data);
      localStorage.removeItem("isWorkshop");
    } else {
      // Need to Check Later
      old_data = old_data?.filter((item) => item?.IsDisabled == false);
      setData(old_data);
      setCurrentCategory(old_data);
    }
  }, [categorySliderData.productCategory, categorySliderData.categories]);

  useEffect(() => {
    if (cart.workshop && cart?.products?.length) {
      getWorkshopsProductCategory(
        cart.workshop?.Id,
        globalData.carData?.modelId
      );
    }
  }, [cart.workshop]);

  useEffect(() => {
    if (cart.workshop == null) {
      // setCartProducts([]);
      // setCartStage(null);
    }
  }, [
    categorySliderData.productCategory,
    categorySliderData.categories,
    apiData.variants,
  ]);

  useEffect(() => {
    setSelected(id);
    setSelctedId(id);
  }, [id]);
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: data?.length > 5 ? 5 : data?.length,
    slidesToScroll: data?.length > 5 ? 5 - 1 : data?.length - 1,
    initialSlide: Number(id) - 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  const onCategoryClick = () => {
    setCartJourney(workshopPurchase);
    setCartStage(1);
  };

  function getPageTitle() {
    if (typeof localStorage !== "undefined") {
      const selectedService = localStorage.getItem("selected-service-title");
      const carData = JSON.parse(localStorage.getItem("car_data") || "{}");
      const brand = carData?.brand || "";
      const locationData = globalData?.locationData?.data || {};
      const emirateArea = locationData.EmirateArea || "";
      return `Product - Open Bonnet : ${
        selectedService ? selectedService : ""
      } ${brand ? `- ${brand}` : ""} ${emirateArea ? `- ${emirateArea}` : ""}`;
    }
    return "Product - Open Bonnet";
  }

  const workshopURL =
    router.query.slug &&
    cart.workshop &&
    router.query.slug[3] == cart.workshop?.Slug;
  if (!(data && cart.workshop)) return null;
  return (
    <div
      id="service-category-area"
      style={{
        borderBottom: "3px solid #e6e6e6",
        position: "fixed",
        background: "#fff",
        zIndex: 1,
        width: "100%",
        marginTop: "-2px",
      }}
    >
      <Container fluid className="px-0">
        {/* <Head>
          <title>{getPageTitle()}</title>
        </Head> */}
        <Col lg={7} md={7} sm={12} className="service-container  pr-5 pt-1">
          {cart.workshop && (
            <h4 className="mt-2  mobstyle">
              {workshopURL ? "Services offered by " : "More services from"}{" "}
              <span className="workshop-title"> {cart.workshop.Name}</span>
            </h4>
          )}
        </Col>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
    getWorkshopsProductCategory: (id, mId) => {
      dispatch(getWorkshopsProductCategory(id, mId));
    },
    getWorkshopsJourneyVariant: (id, cId, mId) => {
      dispatch(getWorkshopsJourneyVariant(id, cId, mId));
    },
    setCartProducts: (products) => {
      dispatch(setCartProducts(products));
    },
    resetWorkshop: () => {
      dispatch(resetWorkshop());
    },
    setSelctedId: (data) => {
      dispatch(setSelctedId(data));
    },
    setCurrentCategory: (data) => {
      dispatch(setCurrentCategory(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Services);
